import PaginatedList from "#root/components/paginated-list";
import RemoteCollection from "#root/utility/remote-collection";
import type { ReactNode } from "react";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { z } from "zod";
import PageLayout from "./layout";

export const SyndicatedArticleListItemSchema = z.object({
  providerCode: z.string(),
  id: z.number(),
  date: z.string(),
  headline: z.string(),
  publisher: z.string(),
  slug: z.string(),
});

export function getSyndicatedArticleCollectionForProvider(providerCode: string) {
  return new RemoteCollection(`/api/account/self/syndicatedContent/provider/${providerCode}/articles`, SyndicatedArticleListItemSchema);
}

export default function ArticleListPage({ providerCode }): ReactNode {
  const articleCollection = useMemo(
    () => getSyndicatedArticleCollectionForProvider(providerCode),
    [providerCode],
  );

  return (
    <PageLayout title="Manage Articles">
      <section>
        <h1>Articles</h1>
        <p>Browse, edit, and retract articles for this syndicated content provider. Use the tracking link to view distribution across networks.</p>

        <PaginatedList title="Articles" collection={articleCollection} refresh={5000}>
          {({ rows }) => (
            <table className="articles">
              <thead>
              <tr>
                <th>Date</th>
                <th>Publisher</th>
                <th>Headline</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              {rows.map(({ id, date, headline, publisher, slug }) => (
                <tr key={id}>
                  <td style={{ whiteSpace: "nowrap" }}>{new Date(date).toLocaleString()}</td>
                  <td>{publisher}</td>
                  <td>{headline}</td>
                  <td>
                    <Link to={slug}>Edit/Retract</Link>&nbsp;&middot;&nbsp;
                    <Link to={`${slug}/tracking`}>Tracking</Link>
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          )}
        </PaginatedList>
      </section>
    </PageLayout>
  );
}
